import React, { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { ORG } from "@/content/worldFarmers";

const Word = ({ word, range, progress, reduce }) => {
  const opacity = useTransform(progress, range, [0.16, 1]);
  const color = useTransform(progress, range, ["#8A9B6E", "#1F2320"]);
  return (
    <motion.span style={reduce ? { opacity: 1, color: "#1F2320" } : { opacity, color }} className="transition-none">
      {word}{" "}
    </motion.span>
  );
};

export const StoryScroll = () => {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const words = ORG.missionFull.split(" ");
  const n = words.length;

  return (
    <section ref={ref} aria-labelledby="mission-heading" className="relative min-h-[200vh] bg-[var(--wf-paper)]">
      <div className="sticky top-0 flex min-h-screen items-center">
        <div className="wf-container py-20">
          <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--wf-maroon)]">
            <span aria-hidden="true" className="h-px w-8 bg-[var(--wf-maroon)]/60" />
            Our mission
          </p>
          <h2 id="mission-heading" className="sr-only">Our mission</h2>
          <p className="mt-6 max-w-4xl font-serif text-2xl font-medium leading-[1.4] tracking-[-0.01em] sm:text-3xl lg:text-[2.5rem] lg:leading-[1.35]">
            {words.map((w, i) => {
              const start = (i / n) * 0.82;
              const end = start + 0.9 / n + 0.06;
              return <Word key={i} word={w} range={[start, Math.min(end, 1)]} progress={scrollYProgress} reduce={reduce} />;
            })}
          </p>
        </div>
      </div>
    </section>
  );
};
